<div
  class="
    ds-fixed
    ds-flex
    ds-flex-col
    ds-z-30
    ds-inset-sm
    ds-w-full
    ds-h-full
    ds-right-0
    ds-top-0
    ds-bottom-0
    ds-left-0
    sm:!ds-w-auto
    sm:!ds-h-auto
    sm:!ds-right-xl
    sm:!ds-bottom-xl
    sm:!ds-top-auto
    sm:!ds-left-auto
    ds-pointer-events-none
  "
  *ngIf="visible"
>
  <section
    ui-error
    [error]="error"
    [ngClass]="{
      'ds-right-0 ds-min-h-full sm:!ds-min-h-fit': open,
      '-ds-right-[111%] ': !open
    }"
    class="
      ds-relative ds-flex ds-flex-col ds-grow ds-mb-0
      sm:!ds-mb-lg
      ds-shadow-2xl
      ds-rounded-md
      ds-overflow-hidden
      ds-bg-primary-white
      ds-transition-all
      ds-duration-500
      ds-pointer-events-auto
    "
  >
    <span #errorMessage>{{ chatAppException }}</span>
    <header
      class="
        ds-border
        ds-border-b-0
        ds-border-tertiary-lightergrey
        ds-rounded-md
        ds-rounded-b-none
        ds-px-lg
        ds-py-[10px]
        ds-text-xl
        ds-z-10
      "
      [class.overflowing]="open"
    >
      {{ chatAppLabel }}

      <button
        class="
          ds-icon ds-icon-cross ds-float-right ds-outline-none
          focus:ds-text-primary-blue
          hover:ds-text-primary-blue
          sm:ds-hidden
        "
        (click)="onToggle()"
      ></button>
      <button
        (click)="onDownloadHistory()"
        [title]="chatAppDownloadHistoryButtonLabel"
        *ngIf="messages.length > 1"
        class="
          ds-icon ds-icon-download ds-float-right ds-outline-none ds-mr-xl
          sm:!ds-mr-0
        "
      ></button>
    </header>
    <div
      #messageWrapperElement
      id="chat-app-messages-wrapper"
      class="
        ds-relative ds-p-lg ds-pt-2xl
        sm:ds-w-[375px] sm:ds-h-[450px]
        ds-overflow-y-scroll
        ds-border-x
        ds-border-tertiary-lightergrey
        ds-grow
        ds-scroll-smooth
        ds-text-sm
      "
    >
      <ng-container *ngFor="let message of messages">
        <message-agent
          *ngIf="message.messageType === 'Agent'"
          [message]="message"
        ></message-agent>
        <message-bot
          *ngIf="message.messageType === 'Bot'"
          [message]="message"
        ></message-bot>
        <message-download
          *ngIf="message.messageType === 'Download'"
          [message]="message"
        ></message-download>
        <message-links
          *ngIf="message.messageType === 'Links'"
          [message]="message"
          (clicked)="onLinkClick($event)"
        ></message-links>
        <message-options
          *ngIf="message.messageType === 'Options'"
          (selected)="onSubmit($event)"
          [message]="message"
        ></message-options>
        <message-user
          *ngIf="message.messageType === 'User'"
          [message]="message"
        ></message-user>
        <message-switch-agent
          *ngIf="message.messageType === 'SwitchAgent'"
          [message]="message"
        ></message-switch-agent>
        <message-switch-bot
          *ngIf="message.messageType === 'SwitchBot'"
          [message]="message"
          (downloadHistory)="onDownloadHistory()"
        >
        </message-switch-bot>
        <message-warning
          *ngIf="message.messageType === 'Warning'"
          [message]="message"
        ></message-warning>
      </ng-container>
      <ui-loading *ngIf="loading" variant="typing"></ui-loading>
    </div>
    <footer *ngIf="!error">
      <form
        #ngForm="ngForm"
        (ngSubmit)="onSubmit(ngForm.value.message)"
        class="ds-relative ds-bg-primary-white"
      >
        <ui-input
          (keydown.enter)="onEnter($event)"
          type="textarea"
          name="message"
          minRows="1"
          maxRows="4"
          required
          fluid
          ngModel
        >
          {{ chatAppInputLabel }}
        </ui-input>
        <button
          [disabled]="ngForm.invalid"
          type="submit"
          class="
            ds-icon ds-icon-send ds-absolute ds-right-[1px] ds-top-[50%]
            -ds-translate-y-1/2
            ds-z-10
            ds-h-[43px]
            ds-w-[65px]
            ds-rounded-md
            ds-outline-none
            ds-bg-primary-white
            disabled:ds-text-tertiary-lightergrey
            focus:ds-text-primary-blue
            hover:ds-text-primary-blue
          "
        ></button>
      </form>
    </footer>
  </section>
  <span
    *ngIf="openTooltip && !open"
    class="
      ds-tooltip ds-open ds-right-align ds-narrow ds-self-end ds-mr-lg
      after:!ds-text-lg
    "
    [attr.aria-label]="chatAppTooltipLabel"
  >
    <div class="ds-w-[60px] ds-mt-2xs"></div>
  </span>
  <button
    class="
      ds-pointer-events-auto
      ds-relative
      ds-icon
      ds-icon-chat
      ds-self-end
      ds-mr-lg
      ds-mb-lg
      before:!ds-text-4xl
      ds-bg-primary-blue
      before:ds-text-primary-white
      ds-shadow-xl
      hover:ds-shadow-lg
      focus:ds-shadow-lg
      ds-outline-none
      ds-shadow-primary-black/30
      ds-h-[60px]
      ds-w-[60px]
      ds-min-h-[60px]
      ds-rounded-full
      ds-rotate-0
      ds-transition-all
      ds-duration-500
    "
    [ngClass]="{
      'ds-icon-cross ds-shadow-none -ds-rotate-180 ds-hidden sm:!ds-block': open
    }"
    (click)="onToggle()"
  >
    <span
      [class.!ds-opacity-100]="unreadMessageCount"
      class="
        ds-absolute ds-opacity-0
        -ds-top-2xs -ds-right-2xs
        ds-rounded-full
        ds-bg-secondary-red
        ds-text-primary-white
        ds-block
        ds-leading-sm
        ds-px-2xs
        ds-h-[1.5rem]
        ds-min-w-[1.5rem]
        ds-transition-all
        ds-duration-250
      "
    >
      {{ unreadMessageCount }}
    </span>
  </button>
</div>
